/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_No_License_P2Inputs */

const es_marketplace_seo_spain_guide_no_license_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_No_License_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal para parejas, familias o grupos de amigos que quieren probar la navegación sin curso previo. Filtra por barcos sin licencia y reserva en minutos.`)
};

const gl_marketplace_seo_spain_guide_no_license_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_No_License_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal para parellas, familias ou grupos de amigos que queren probar a navegación sen curso previo. Filtra por barcos sen licenza e reserva en minutos.`)
};

const en_marketplace_seo_spain_guide_no_license_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_No_License_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal for couples, families or friends who want to try boating without prior training. Filter by licence-free boats and book in minutes.`)
};

/**
* | output |
* | --- |
* | "Ideal for couples, families or friends who want to try boating without prior training. Filter by licence-free boats and book in minutes." |
*
* @param {Marketplace_Seo_Spain_Guide_No_License_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_no_license_p2 = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_No_License_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_No_License_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_no_license_p2(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_no_license_p2(inputs)
	return es_marketplace_seo_spain_guide_no_license_p2(inputs)
});